import {GET_CLAIM_REQUEST, GET_CLAIM_SUCCESS,GET_CLAIM_FAILUER } from "./types"

const initialState = {
    loading: false,
    error: null,

    getclaimdata: null
}
const getclaimdatareducer = (state = initialState, action) => {
    
    switch (action.type) {
        case GET_CLAIM_REQUEST:
            return {
                ...state,
                loading: true,
                // error: null,
            }
        case GET_CLAIM_SUCCESS: {

            
            
            return {
                ...state,
                loading: false,
                getclaimdata: action.payload
            }
        }
        case GET_CLAIM_FAILUER:
            return {
                ...state,
                loading: false,
                // error: action.payload.message,
            }

        default:
            return state
    }
}

export default getclaimdatareducer